<template>
  <section class="ebook-mobile">
    <div class="container-hts">
      <FilterMobile
        v-if="classes && ebooks && ebooks.length"
        :classes="classes"
        :selectClass="selectClass"
        :bookGroups="bookGroups"
        :bookTypes="bookTypes"
        :ebooks="ebooks"
        @filterClass="filterClass"
        @filterGroup="filterGroup"
        @filterType="filterType"
      />
      <div class="ebooks-list list__box__body">
        <div class="row">
          <ItemBook v-for="(item, index) of dataBooks" :key="index" :itemBook="item" class="col-6 col-sm-4" />
        </div>
      </div>
      <!-- <div class="ebook-filter">
        <div class="select-custom">
          <select name="select_book_type" @change="displayBookType">
            <option v-for="(item, index) of bookTypes" :key="`filter_${index}`" :value="index" :selected="tabActive == index">{{ item }}</option>
          </select>
          <i class="icon-arrow-down primary-color font-size-12"></i>
        </div>
      </div>
      <div class="ebook-type-1" v-if="!bookGroupType0">
        <div v-for="(group, index) in ebooks" :key="index" class="ebook-list" v-if="displayEbook === parseInt(index)">
          <div class="ebook-list__body list__box__body">
            <div class="ebook-list__item" v-for="(item, pos) of group.bookGroups" :key="`section_${pos}`">
              <div class="ebook-list__head display-flex justify-content-between">
                <h2 class="font-size-20 font-sanpro-semibold margin-0 ebook-list__title">{{ item.name }}</h2>
                <a href="javascript:;" class="ebook-list__more primary-color" @click="viewMoreBooks(item, group.bookTypeId, selectClass)">Xem tất cả</a>
              </div>
              <div class="ebook-list__data position-rel">
                <swiper v-if="item.books && item.books.length > 0" :options="{slidesPerView: 3, spaceBetween: 20, slidesPerGroup: 1, grabCursor: true, loop: false, loopFillGroupWithBlank: true, breakpoints: {767: {slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 10 }, 575: {slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 } }, navigation: {nextEl: `.ebook__next_${pos}`, prevEl: `.ebook__prev_${pos}`}}">
                  <swiperSlide v-for="(book, loc) of item.books" :key="`book_${loc}`"><ItemBook :itemBook="book" /></swiperSlide>
                  <div class="swiper-button-prev" :class="`ebook__prev_${pos}`" slot="button-prev"></div>
                  <div class="swiper-button-next text-right" :class="`ebook__next_${pos}`" slot="button-next"></div>
                </swiper>
                <h3 class="secondary-color-txt font-size-20 text-center" v-else>Sách đang cập nhật</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ebook-type-2" v-else>
        <div class="ebook-list__body list__box__body">
            <div class="ebook-list__item">
              <div class="ebook-list__data position-rel">
                <swiper v-if="ebooks[0].bookGroups[displayEbook].books && ebooks[0].bookGroups[displayEbook].books.length > 0" :options="{slidesPerView: 3, spaceBetween: 20, slidesPerGroup: 1, grabCursor: true, loop: false, loopFillGroupWithBlank: true, breakpoints: {767: {slidesPerView: 2, slidesPerGroup: 1, spaceBetween: 10 }, 575: {slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 10 } }, navigation: {nextEl: `.ebook__next_0`, prevEl: `.ebook__prev_0`}}">
                  <swiperSlide v-for="(book, loc) of ebooks[0].bookGroups[displayEbook].books" :key="`book_${loc}`"><ItemBook :itemBook="book" /></swiperSlide>
                  <div class="swiper-button-prev" :class="`ebook__prev_0`" slot="button-prev"></div>
                  <div class="swiper-button-next text-right" :class="`ebook__next_0`" slot="button-next"></div>
                </swiper>
                <h3 class="secondary-color-txt font-size-20 text-center" v-else>Sách đang cập nhật</h3>
              </div>
            </div>
          </div>
      </div> -->
    </div>
  </section>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex';
  import {STORE_KEY, LOCAL_SAVE_BOOK_TYPE, LOCAL_SAVE_TAB_LISTPAGE} from '../_store/constants'
  import store from '../_store'
  // import EBookFilter from './EBookFilter'
  import FilterMobile from './ebooklist/FilterMobile'
  import { APP_CONFIG } from '@/utils/constants'
  // import { swiper, swiperSlide } from 'vue-awesome-swiper'
  // import 'swiper/dist/css/swiper.css'
  import ItemBook from './ebooklist/ItemBook.vue'
  // const imgNext = require('@/assets/images/next.png')
  // const imgPrev = require('@/assets/images/prev.png')
  // const imgBookType1 = require('@/assets/images/book/book_type_1.png')
  // const imgBookType2 = require('@/assets/images/book/book_type_2.png')
  // const imgBanner = require('@/assets/images/banner.png')

export default {
  name: 'EBookList_Mobi',
  components: {
    // EBookFilter,
    // swiper, 
    // swiperSlide,
    ItemBook,
    FilterMobile
  },
  props: {
    classes: Array,
    selectClass: Number
  },
  data() {
    return {
      // displayEbook: 0,
      bookTypes: [],
      bookGroups: [],
      // imgBookType1,
      // imgBookType2,
      // imgBanner,
      cdnUrl: APP_CONFIG.cdnUrl,
      // bookGroupType0: false,
      // tabActive: null,
      dataBooks: []
    }
  },
  computed: {
    ...mapGetters({
      ebooks: STORE_KEY + '/ebooks',
      filterObj: STORE_KEY + '/ebooksFilter',
    }),
    bookGroupActive () {
      return this.$route.query.book_active || 0
    }
  },
  watch: {
    'ebooks': 'setBookTitleGroup'
  },
  mounted () {
    this.setBookTitleGroup()
  },
  methods:{
    setBookTitleGroup () {
      let self = this;
      self.bookGroups = []
      self.bookTypes = []
      if(self.ebooks.length > 0) {
        if(self.ebooks[0].bookTypeId === 0) {
          // self.bookGroupType0 = true;
          self.ebooks[0].bookGroups.map(book => {
            self.bookTypes.push(book.name);
          })
        } else {
          // self.bookGroupType0 = false;
          self.ebooks.map(book => {
            self.bookGroups.push(book.name);
          })
          self.setBookTypes()
        }
        self.filterBooksData();
      }
    },

    setBookTypes () {
      let self = this
      self.bookTypes = []
      if(self.ebooks.length > 0 && self.bookGroupActive > -1) {
        self.ebooks[self.bookGroupActive].bookGroups.map(type => {
          self.bookTypes.push(type.name)
        })
      }
    },

    filterBooksData (typeActive = 0) {
      this.dataBooks = []
      if(this.ebooks.length > 0 && this.bookGroupActive > -1) {
        this.dataBooks = this.ebooks[this.bookGroupActive].bookGroups[typeActive].books
      }
    },

    filterClass (val) {
      this.$emit('filterClass', val)
    },

    filterGroup (index) {
      this.setBookTypes()
      this.filterBooksData()
    },

    filterType (index) {
      this.filterBooksData(index)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './../../../assets/scss/_variables';
  @import './../../../assets/scss/_mixins';
  @import './../../../assets/scss/general';

  .ebook-mobile {
    padding: 20px 0;
  }

  .ebook-filter {
    margin-bottom: 30px;

    select {
      @extend .full-width;
      @extend .border-rd-20;
      background: $color_bg_gray_light;
      @extend .border-0;
      height: 35px;
      padding: 0 15px;
    }

    i {
      line-height: 35px;
    }
  }

  .ebook-list {
    &__desc {
      margin-bottom: 25px;

      figure {
        box-shadow: none;
        -webkit-box-shadow: none;
        @extend .border-0;
        width: 35%;
        margin: 0 auto 30px;
      }
    }

    &__item {
      margin-bottom: 35px;
    }

    &__head {
      padding-bottom: 10px;
      border-bottom: 1px solid $primary_text_color;
    }

    &__data {
      padding: 20px 0;
      @media screen and ( min-width: 768px ) {
        padding: 25px 0;
      }
    }

    &__title {
     @media screen and ( min-width: 768px ) {
        font-size: 22px;
      } 
    }
  }
  .swiper-button-prev, .swiper-button-next {
    margin-top: -50px;
  }
  .swiper-button-prev {
    left: 0;
  }

  .swiper-button-next {
    right: 0;
    background-position: top right;
  }
</style>